export default __webpack_public_path__ + "a050ff278fe24385899bcaefc4925bf1.svg";